import apiClient from './apiClient';

export const mapApi = {
  queryMapData: async (payload) => {
    const response = await apiClient.post('/mapdata/query', payload, {
      suppressGlobalErrorToast: true,
    });
    return response.data;
  },
  geocode: async (query) => {
    const response = await apiClient.post('/geocoding/geocode', { query }, {
      suppressGlobalErrorToast: true,
    });
    return response.data;
  }
};
